import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { countryReference } from 'src/app/utils/constants/strings';
import { postalCodePatternValidation } from 'src/app/utils/utils';
import { AddressService } from '../../../address/service/address/address.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SnackBarService } from 'src/app/shared/snack-bar/services/snack-bar.service';
import {
  basicSnackBarConfig,
  createConfigArray,
} from 'src/app/utils/default-configs/configuration';
import { motherShipperDeatilsconfiguration } from 'src/app/utils/constants/constant';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mother-shipper-details',
  templateUrl: './mother-shipper-details.component.html',
  styleUrls: ['./mother-shipper-details.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MotherShipperDetailsComponent implements OnInit {
  shipperdetailsForm: FormGroup;
  cityList = [];
  list = countryReference;
  isPostalCodeReq: boolean;
  isPostalCodeValid: boolean = true;
  isCityValid: boolean = true;
  filteredCountry = countryReference;
  motherShipperBtn: boolean;
  validPostalCodeCityname: string;
  motherShipperData;
  shipperData;
  isBabyLineManifest: boolean=false;
  action;
  index;
  isLbx;
  constructor(
    private fb: FormBuilder,
    private addressService: AddressService,
    private configService: ConfigService,
    private snackBarService: SnackBarService,
    private dialogRef: MatDialogRef<MotherShipperDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    if (data.labelName != null) {
      this.shipperData = data.mappingData;
      this.action = data.labelName;
      this.index = data.index;
      this.motherShipperData = data.configData;
      this.isBabyLineManifest = this.motherShipperData?.isBabyLineManifest ?? false;
    }
  }

  ngOnInit(): void {
    this.getWorkflowConfig();
    this.intialiseShipperFormGroup();
    this.msCountrySearchInitialise();
    this.msCitySearchInitialise();
    this.msPinCodeSearchInitialise();
    this.patchMotherAddressForm();
  }

  getWorkflowConfig() {
    this.configService.fetchConfig('loose_bbx').then(response => {
      const bbxWorkflow = response.data[0];
      this.isLbx = bbxWorkflow === 'Yes' ? true : false;
    });
  }

  patchMotherAddressForm() {
    if (this.action === 'Edit') {
      this.shipperdetailsForm.patchValue(this.shipperData);
    }
  }

  msCountrySearchInitialise() {
    this.shipperdetailsForm.controls.shipperCountryName.valueChanges.subscribe(newValue => {
      this.list = this.filteredCountry.filter(
        value => value?.name.toLowerCase().indexOf(newValue?.trim().toLowerCase()) === 0
      );
    });
  }

  msCitySearchInitialise() {
    this.shipperdetailsForm.controls.shipperCityName.valueChanges
      .pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        const currCity = this.cityList.some(con => con.city == newValue.trim());
        if (!currCity) {
          if (newValue.trim().length >= 3) {
            this.addressService
              .getPostalCodeServiceableArea(
                this.shipperdetailsForm.get('shipperCountryCode').value,
                newValue.trim(),
                ''
              )
              .subscribe((response: any) => {
                const currCountryCode = this.shipperdetailsForm.get('shipperCountryCode').value;
                if (currCountryCode != undefined) {
                  this.isPostalCodeReq = this.list.find(
                    con => con.code === currCountryCode
                  ).isPostalCodeServiceAvailable;
                }

                this.cityList = response?.postalLocationList;

                if (this.cityList.length > 0) {
                  if (this.shipperdetailsForm.get('shipperCityName').value != '') {
                    this.isCityValid =
                      this.cityList.some(con => con.city == newValue.trim().toUpperCase()) ||
                      this.validPostalCodeCityname.trim().toUpperCase() ==
                        newValue.trim().toUpperCase();
                  }
                } else {
                  this.isCityValid = false;
                }
              });
          }
        } else {
          this.isCityValid = true;
        }
      });
  }

  msPinCodeSearchInitialise() {
    this.shipperdetailsForm.controls.shipperPostalCode.valueChanges
      .pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe(newValue => {
        if (
          this.shipperdetailsForm.get('shipperCountryCode').value == 'CA' ||
          this.shipperdetailsForm.get('shipperCountryCode').value == 'GB'
        ) {
          newValue = postalCodePatternValidation(
            this.shipperdetailsForm.get('shipperCountryCode').value,
            newValue
          );
        }
        const currPostalCode = this.cityList.some(con => con.postalCode == newValue.trim());
        if (!currPostalCode) {
          if (newValue.trim().length >= 3) {
            this.addressService
              .getPostalCodeServiceableArea(
                this.shipperdetailsForm.get('shipperCountryCode').value,
                '',
                newValue.trim()
              )
              .subscribe((response: any) => {
                this.cityList = response?.postalLocationList;

                if (this.cityList.length > 0) {
                  if (
                    this.isPostalCodeReq &&
                    this.shipperdetailsForm.get('shipperPostalCode').value != ''
                  ) {
                    this.isPostalCodeValid = this.cityList.some(
                      con => con.postalCode == newValue.trim()
                    );
                    if (this.isPostalCodeValid) {
                      this.validPostalCodeCityname = this.cityList.find(
                        con => con.postalCode == newValue.trim()
                      ).city;
                    }
                  }
                } else {
                  this.isPostalCodeValid = false;
                }
              });
          }
        } else {
          this.isPostalCodeValid = true;
          this.cityList = this.cityList.filter(value => value?.postalCode.indexOf(newValue) === 0);
        }
      });
  }

  intialiseShipperFormGroup() {
    this.shipperdetailsForm = this.fb.group({
      addressId: '',
      workflow: '',
      isDefault: new FormControl(false),
      isBabyLineManifest:new FormControl(false),
      shipperCompanyName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(60)])
      ),
      shipperNickName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(60)])
      ),
      shipperContactPersonName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
      shipperAddressLine1: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(45)])
      ),
      shipperAddressLine2: new FormControl('', Validators.compose([Validators.maxLength(45)])),
      shipperAddressLine3: new FormControl('', Validators.compose([Validators.maxLength(45)])),
      shipperCityName: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(35)])
      ),
      shipperCountryName: new FormControl('', Validators.compose([Validators.maxLength(45)])),
      shipperPostalCode: new FormControl('', Validators.compose([Validators.required])),
      shipperCountryCode: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(2), Validators.minLength(2)])
      ),
      shipperProvinceCode: new FormControl('', Validators.compose([Validators.maxLength(35)])),
      shippersuburb: new FormControl('', Validators.compose([Validators.maxLength(45)])),
      shipperEmail: new FormControl(
        '',
        Validators.compose([Validators.maxLength(50), Validators.email])
      ),

      shipperMobilePhone: new FormControl(
        '',
        Validators.compose([Validators.maxLength(25), Validators.pattern('[- +()0-9]+')])
      ),
      shipperPhone: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(25),
          Validators.pattern('[- +()0-9]+'),
        ])
      ),
    });
  }

  isPostalCodeCityValid() {
    return this.isPostalCodeValid && this.isCityValid;
  }

  selectionChanged(eventVal: string) {
    this.motherShipperBtn = false;
    if (eventVal != '') {
      const countryCode = this.list.find(con => con.name === eventVal).code;
      this.shipperdetailsForm.get('shipperCountryCode').patchValue(countryCode);
      this.isPostalCodeValid = true;
      this.shipperdetailsForm.get('shipperPostalCode').setValue('');
      this.shipperdetailsForm.get('shipperCityName').setValue('');
      this.shipperdetailsForm.get('shippersuburb').setValue('');
      this.addressService
        .getPostalCodeServiceableArea(
          this.shipperdetailsForm.get('shipperCountryCode').value,
          '',
          ''
        )
        .subscribe((response: any) => {
          this.cityList = response?.postalLocationList;
        });
      this.isPostalCodeReq = this.list.find(
        con => con.code === countryCode
      ).isPostalCodeServiceAvailable;
      if (!this.isPostalCodeReq) {
        this.shipperdetailsForm.get('shipperPostalCode').disable();
        this.isPostalCodeValid = true;
      } else {
        this.shipperdetailsForm.get('shipperPostalCode').enable();
      }
    } else {
      this.shipperdetailsForm.get('shipperCountryCode').setValue('');
    }
  }

  saveShipperConfig() {
    if (this.isLbx) {
      this.shipperdetailsForm.get('workflow').setValue('lbx');
    } else {
      this.shipperdetailsForm.get('workflow').setValue('bbx');
    }
    this.shipperdetailsForm
      .get('shipperCountryName')
      .setValue(this.shipperdetailsForm.value.shipperCountryName.toUpperCase());
    this.shipperdetailsForm
      .get('shipperCityName')
      .setValue(this.shipperdetailsForm.value.shipperCityName.toUpperCase());
    const shipperFormData = this.shipperDetails(this.shipperdetailsForm.value);

    if (this.action === 'Edit') {
      this.motherShipperData.data[this.index] = shipperFormData;
      this.resetDefaultAddress(this.index, shipperFormData.isDefault);
    } else {
      if (!this.motherShipperData) {
        this.motherShipperData = {};
        this.motherShipperData.data = [];
        this.motherShipperData.data.push(shipperFormData);
      } else {
        this.motherShipperData.data.push(shipperFormData);
      }
      this.resetDefaultAddress(this.motherShipperData.data.length - 1, shipperFormData.isDefault);
    }
    const configData = {
      config_id: 'mother_shipperdetails',
      data: this.motherShipperData.data,
    };

    this.saveConfig(configData);
    this.motherShipperBtn = true;
  }
  shipperDetails(obj: any): any {
    for (const key in obj) {
      if (obj[key] && typeof obj[key] === 'object') {
        obj[key] = this.shipperDetails(obj[key]);
      } else if (typeof obj[key] === 'string') {
        obj[key] = obj[key].trim();
      }
    }
    return obj;
  }

  resetDefaultAddress(index, isDefault) {
    if (isDefault) {
      this.motherShipperData.data.forEach((obj, idx) => {
        obj.isDefault = idx === index;
      });
    }
  }

  saveConfig(config) {
    this.configService.saveConfig(config).subscribe(res => {
      this.configService.putConfig(res.config_id, res.data);
      this.dialogRef.close('true');
      this.snackBarService.createSnackBar(
        basicSnackBarConfig.addressComponentSave?.message,
        basicSnackBarConfig.addressComponentSave?.horizontalPosition,
        basicSnackBarConfig.addressComponentSave?.verticalPosition,
        basicSnackBarConfig.addressComponentSave?.duration
      );
    });
  }

  setDefault(checked) {
    this.shipperdetailsForm.get('isDefault').setValue(checked);
  }

  selectionPincodeChanged(event, item) {
    if (event.isUserInput) {
      this.motherShipperBtn = false;
      this.shipperdetailsForm.get('shipperCityName').setValue(item?.city);
      this.isCityValid = true;
    }
  }

  selectionCityChanged(event, item) {
    this.motherShipperBtn = false;
    if (!item?.postalCode) {
      this.shipperdetailsForm.get('shipperPostalCode').disable();
      if (event.isUserInput) {
        if (item?.cityDistrict) {
          this.shipperdetailsForm.get('shippersuburb').setValue(item?.cityDistrict);
        }
      }
    } else {
      this.shipperdetailsForm.get('shipperPostalCode').enable();
      if (event.isUserInput) {
        this.shipperdetailsForm.get('shipperPostalCode').setValue(item?.postalCode);
      }
    }
  }
}
